(function () {
    var $box = $('#products .span3 a'),
        $window = $(window),
        boxesHeights = [],
        applyMaxHeight = function () {
            boxesHeights = [];
            $box.height('auto');
            $box.each(function () {
                boxesHeights.push($(this).height());
            });
            $box.height(Math.max.apply(Math, boxesHeights) + 'px');
        };

    $(window).on('fontsLoaded', function(){
        applyMaxHeight();
    });

    $window.on('resize', function () {
        applyMaxHeight();
    });
})();


(function(){
    var defaultFont = 'Helvetica Neue,Helvetica,Arial,sans-serif',
        text = '!Am19/*@{}QE%',
        timeout = 50,
        limit = 3050,
        waitForWebfonts = function () {
            function compare (origSize, fonts, numFonts) {
                var changed = [],
                    size,
                    $el,
                    $els = $(this);

                limit = limit - timeout;
                for (var i = 0; i < numFonts; i++) {
                    $el = $(this[i]);
                    $el.css('fontFamily', fonts[i] + ', ' + defaultFont);
                    size = {x: $el.width(), y: $el.height()};

                    if (JSON.stringify(origSize[i]) !== JSON.stringify(size)) {
                        changed[i] = true;
                    }
                }

                if (changed.length === numFonts) {
                    $(window).trigger('fontsLoaded');
                    $('[id*="waitforwebfonts"]').remove();
                } else {
                    if (limit > 0) {
                        setTimeout(function(){compare.call($els, origSize, fonts, numFonts)}, timeout);
                    } else {
                        console.warn('waitForWebfonts(): Loading fonts took too long.');
                    }
                }
            }

            $('[id*="waitforwebfonts"]').remove();

            var fonts = arguments[0], 
                $els,
                origSize = [],
                size,
                result,
                numFonts = fonts.length;

            for (var i = 0; i < numFonts; i++) {
                $('body').append($('<div id="waitforwebfonts-' + i + '" />')
                                 .text(text)
                                 .css({
                    position: 'absolute',
                    left: '-5000px',
                    top: '-5000px',
                    fontSize: '24px',
                    fontFamily: defaultFont
                })
                                );
            }

            $els = $('[id*="waitforwebfonts"');
            for (var i = 0; i < numFonts; i++) {
                origSize[i] = {x: $($els[i]).width(), y: $($els[i]).height()};
            }

            compare.call($els, origSize, fonts, numFonts);
        }

    waitForWebfonts(['Proxima Nova']);
})();

(function(){
    var $ =  avm.require('jquery'),
        decorate =  avm.require('avast.web.linkDecorator'),
        unserialize = avm.require('avast.url.unserialize');

    $('.share-icons-icon > a').each(function(index){
        var loc = encodeURIComponent(document.location.href),
            querystring = this.search ? this.search.substr(1) : '',
            params = unserialize(querystring);

        if(params['u']){
            decorate(this, 'u', querystring, 'u=' + loc)
        }

        if(params['status']){
            decorate(this, 'status', querystring, 'status=' + loc)
        }

        if(params['url']){
            decorate(this, 'url', querystring, 'url=' + loc)
        }
    })
})();